import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Icon } from 'loyal-react'

class WishlistHeart extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: false
    }
  }
  toggleWishlist = () => {
    this.handleLoading()
    this.props.toggleWishlist()
  }
  handleLoading = () => {
    this.setState({ isLoading: !this.state.isLoading })
  }
  componentDidUpdate (prevProps) {
    if (this.state.isLoading && prevProps.isInWishlist !== this.props.isInWishlist) {
      this.handleLoading()
    }
  }
  render () {
    return <a href='javascript:void(0)'
      className='box-card-link-wishlist'
      onClick={this.toggleWishlist}
      aria-label={this.state.isLoading ? 'Carregando...' : (this.props.isInWishlist
        ? 'Remover dos favoritos'
        : 'Adicionar aos favoritos')}>
      <Icon
        iconName={
          this.state.isLoading ? 'icon_loading' : (this.props.isInWishlist
            ? 'icon_wishlist_color'
            : 'icon_wishlist')
        }
        className={`txt-body-lg pointer r-0 t-0 ${this.props.className}`}
      />
    </a>
  }
}

WishlistHeart.propTypes = {
  isInWishlist: PropTypes.bool.isRequired,
  toggleWishlist: PropTypes.func.isRequired,
  className: PropTypes.string
}

WishlistHeart.defaultProps = {
  isInWishlist: false,
  className: ''
}

export default WishlistHeart



// WEBPACK FOOTER //
// ./src/Wishlist/WishlistHeart/WishlistHeart.js